/**
 * validation.builder.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */


import { ValidatorFn, Validators } from "@angular/forms";
import { TypedDataHolder } from "../common/data/typed-data";
import { CustomValidators } from "../support/validators";

export class ValidationBuilder {
    public static isMandatory (data : TypedDataHolder) : boolean
    {
        return false;
        // TODO: reevaluate if we need any mandatory steps
        // return (data instanceof IntakeStep
        //     && (data.classifications.indexOf("hint-mandatory") > -1
        //         || data.classifications.indexOf("Mandatory") > -1
        //     ));
    }

    public static for (data : TypedDataHolder)
        : ValidatorFn[]
    {
        const validators : ValidatorFn[] = [];
        if (ValidationBuilder.isMandatory(data))
        {
            validators.push(Validators.required);
        }
        switch (data.type)
        {
            case "natural number":
                validators.push(
                    CustomValidators.nullOr(
                        [
                            CustomValidators.integer,
                            CustomValidators.safeInteger,
                            CustomValidators.min(1)
                        ]
                ));
                break;
            case "whole number":
                validators.push(
                    CustomValidators.nullOr(
                        [
                            CustomValidators.integer,
                            CustomValidators.safeInteger,
                            CustomValidators.min(0)
                        ]
                ));
                break;
            case "integer":
                validators.push(
                    CustomValidators.nullOr(
                        [
                            CustomValidators.integer,
                            CustomValidators.safeInteger
                        ]
                ));
                break;
            case "float":
                validators.push(
                    CustomValidators.nullOr(
                        CustomValidators.number));
                break;
            default:
                // nothing
        }
        if (data.restrictions && data.restrictions.length)
        {
            if (data.cardinality === 1 || data.allowsDuplicates)
            {
                validators.push(
                    CustomValidators.in(
                        data.restrictions.concat(data.value)));
            }
            else
            {
                validators.push(
                    CustomValidators.subset(
                        data.restrictions.concat(data.value)));
            }
        }
        return validators;
    }

    public static forTableColumn (data : TypedDataHolder) : ValidatorFn[]
    {
        return [];
        // CustomValidators.noInternalNulls
    }
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/intake-form/validation.builder.ts